import axios from "axios";
import { Constants } from "../constants/Contants";
import { LocalStorageKeys } from "../constants/LocalStorageKeys";
import {getContext, getTimezone} from "./context";
import { AppError, UnauthorizedError } from "./customError";
import store from "../store/store";
import { clearUser, setUser } from "../Slices/User/userDataSlice";
import { setCurrency } from "./context";

const NO_REDIRECT_ROUTES = ["/esim/payment-step", "/flight-checkout"];

let instance = axios.create({});
instance.interceptors.request.use(async (config) => {
  var jwtToken = await localStorage.getItem('teleport_token');
  const hasExplicitAuthorization = Boolean(
    config.headers?.Authorization || config.headers?.get?.("Authorization")
  );
  if (!hasExplicitAuthorization) {
    config.headers.Authorization = jwtToken ? `${jwtToken}` : "";
  }
  config.baseURL = Constants.baseURL;
  // config.timeout = 10000;
  config.withCredentials = true;

  const context = getContext();
  config.headers['X-Ctx-Client-Id'] = context.clientId;
  config.headers['X-Ctx-Client-Type'] = context.clientType;
  config.headers['X-Ctx-Currency'] = context.currency;
  config.headers['X-Ctx-Timezone'] = getTimezone();

  const t = Date.now();
  config.params = {
    ...config.params,
    t
  };

  return config;
});
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const noRedirect = NO_REDIRECT_ROUTES.some((p) =>
      window.location.pathname.startsWith(p)
    );

    if ([401, 403].includes(error?.response?.status)) {
      store.dispatch(clearUser());
      localStorage.removeItem("teleport_token");
      setCurrency("USD");

      if (!noRedirect) {
        window.location.href = "/login";
      }
    }

    if (error?.response) {
      return error.response;
    }

    return Promise.reject(error);
  }
);

export async function post(url, params = {}, headers={}) {
  try {
    const response = await instance.post(url, params, {
      headers: { "Content-Type": "application/json", ...headers },
    });


    if (response.status === 401 || response.status === 403) {
      throw new UnauthorizedError(response.data?.message ?? '');
    }
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? '');
    }

    const res = response?.data;
    let data = res?.data;
    let isSuccess = res?.status;

    if (false === isSuccess) {
      throw new AppError(res.message, res.errorCode);
    }

    return data;
  } catch (error) {
    console.error("post error:", error);
    throw error;
  }
}

export async function get(url, params = {}, headers={}) {
  try {
    const response = await instance.get(url, {
      params,
      headers,
    });
    
    if (response.status === 401 || response.status === 403) {
      throw new UnauthorizedError(response.data?.message ?? '');
    }
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? '');
    }

    const res = response?.data;
    let data = res?.data;
    let isSuccess = res?.status;

    if (false === isSuccess) {
      throw new AppError(res.message, res.errorCode);
    }

    return data;
  } catch (error) {
    console.error("get error:", error);
    throw error;
  }
}

export async function patch(url, params = {}, headers = {}) {
  try {
    const response = await instance.patch(url, params, {
      headers: { "Content-Type": "application/json", ...headers },
    });
    if (response.status === 401 || response.status === 403) {
      throw new UnauthorizedError(response.data?.message ?? "");
    }
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "");
    }
    const res = response?.data;
    if (res?.status === false) throw new AppError(res.message, res.errorCode);
    return res?.data;
  } catch (error) {
    console.error("patch error:", error);
    throw error;
  }
}

export async function del(url, params = {}, headers = {}) {
  try {
    const response = await instance.delete(url, {
      data: params,
      headers: { "Content-Type": "application/json", ...headers },
    });
    if (response.status === 401 || response.status === 403) {
      throw new UnauthorizedError(response.data?.message ?? "");
    }
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? "");
    }
    const res = response?.data;
    if (res?.status === false) throw new AppError(res.message, res.errorCode);
    return res?.data;
  } catch (error) {
    console.error("delete error:", error);
    throw error;
  }
}
